import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=447f0680&"
import script from "./supplier.vue?vue&type=script&lang=ts&"
export * from "./supplier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "supplier.vue"
export default component.exports